import { useQuery } from "react-query";
import CategoryService from "../../services/categoryService";
import { FC } from "react";
import { TUseSearchProductPageResponse } from "../../hooks/useSearchProductPage";
import { UiDropdown } from "../dropdown/UiDropdown";
import { useTranslation } from "react-i18next";
import { icArrowDown2 } from "../image/image-src";

export const CateSortBtn: FC<TUseSearchProductPageResponse> = (jj) => {
  const { t } = useTranslation();
  const { data: categories } = useQuery(["categories", jj.type], async () => {
    const result = await CategoryService.getCategories(jj.type);
    return result || [];
  });
  return (
    <div className="group relative after:absolute after:-right-2 after:h-2 after:w-full after:content-['']">
      <button className="relative flex items-center gap-[0.5625rem] border-b border-[#83929D]">
        <p className="text-[0.875rem] font-normal leading-[1.25rem] text-[#232323]">
          {jj.search?.category
            ? categories?.find((c) => String(c.id) === jj.search.category)?.name || t("Main/sub category")
            : t("Main/sub category")}
        </p>
        <img
          className="h-[0.8125rem] w-[0.8125rem]"
          src={icArrowDown2}
          alt=""
        />
      </button>
      <UiDropdown>
        <ul>
          <li
            className={`h-12 cursor-pointer content-center p-3 ${!jj.search?.category ? "bg-primary" : ""
              }`}
          >
            <button type="button" onClick={() => jj.onChooseCate(0)}>
              {t("All categories")}
            </button>
          </li>
          {categories?.map((category) => (
            <li
              key={category.id}
              className={`h-12 cursor-pointer content-center p-3 ${category.id + "" === jj.search?.category ? "bg-primary" : ""
                }`}
              onClick={() => jj.onChooseCate(category.id)}
            >
              <button
                type="button"
              >
                {category.name}
              </button>
            </li>
          ))}
        </ul>
      </UiDropdown>
    </div>
  );
};
